export const shouldHideGlobalSearchProjectSelector = (pathname: string, isProjectSelectorHiddenBySource: boolean) =>
  isProjectSelectorHiddenBySource || pathname === '/dashboard';
